import { render, staticRenderFns } from "./MaxMinView.vue?vue&type=template&id=60fa0b41&scoped=true&"
import script from "./MaxMinView.vue?vue&type=script&lang=js&"
export * from "./MaxMinView.vue?vue&type=script&lang=js&"
import style0 from "./MaxMinView.vue?vue&type=style&index=0&id=60fa0b41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa0b41",
  null
  
)

export default component.exports